import { withStateHandlers, withState, withHandlers } from 'recompose'
import { compose, assoc, isEmpty, isString, isNil, isFunction } from 'lodash/fp'
import { omitByRecursively } from 'utils/dynaHelp'

export default ({ initialValues, validator, onSuccess }) => compose(
  withState('errors', 'setErrors', {}),
  withStateHandlers(props => ({ values: isFunction(initialValues) ? initialValues(props) : initialValues }), {
    handleChange: ({ values }) => (key, value) => ({ values: assoc(key)(value)(values) })
  }),
  withHandlers({
    save: ({ setErrors, ...otherProps }) => values => {
      let errors = validator(values)
      errors = omitByRecursively(errors, (v, k) => isEmpty(v))
      if (isEmpty(errors)) {
        const clean = omitByRecursively(values, (v, k) => isString(v) ? isEmpty(v) : isNil(v))
        return onSuccess(otherProps, clean).catch(err => {
          setErrors({ __error: err })
          throw err
        })
      } else {
        setErrors(errors)
        return Promise.reject('Save failed')
      }
    }
  })
)


// WEBPACK FOOTER //
// ./src/utils/withForm.js